import React from 'react';
import './breadcrumbs.scss';

export interface BreadcrumbInterface {
    title: string;
    [key: string]: any;
}

export interface BreadcrumbProps {
    breadcrumbs: BreadcrumbInterface[];
}

const Breadcrumbs = ({ breadcrumbs }: BreadcrumbProps) => {
    const breadcrumbsContent = breadcrumbs.map((value, key) => {
        let url;
        if (value.hasOwnProperty('url')) {
            url = value.url;
        } else {
            url = value.relative_url;
        }
        // The last breadcrumb (current page) should not be a link
        return breadcrumbs.length !== key + 1 ? (
            <li key={`breadcrumb-${key}`}>
                <a
                    style={{ textDecoration: 'underline', color: 'black' }}
                    href={url}
                    title={value.title}
                >
                    {value.title}
                </a>
                <div
                    data-testid="breadcrumbs-slash"
                    className="breadcrumbs-divider"
                >
                    /
                </div>
            </li>
        ) : (
            <li key={`breadcrumb-${key}`}>{value.title}</li>
        );
    });
    return (
        <div className="breadcrumbs" data-spec="breadcrumbs">
            <ol>{breadcrumbsContent}</ol>
        </div>
    );
};

export default Breadcrumbs;
